import { type SnackbarVariant } from "@/components/Snackbar";
import { enqueueSnackbar } from "notistack";

type SnackbarOptions = {
  subtitle?: string;
  actions?: JSX.Element[];
  close?: boolean;
};

type TransientSnackbarOptions = SnackbarOptions & {
  variant?: Exclude<SnackbarVariant, "error">;
};

function enqueueCustomSnackbar(
  message: string,
  {
    subtitle,
    actions,
    close = true,
    variant,
    persist
  }: SnackbarOptions & { variant: SnackbarVariant; persist?: boolean }
) {
  const show = () => {
    enqueueSnackbar(message, {
      variant,
      persist,
      action: actions,
      subtitle,
      close
    });
  };

  // Tests close dialogs immediately; the production delay then enqueues into a
  // SnackbarProvider that has not mounted yet and failOnConsole fails the suite.
  if (import.meta.env.MODE === "test") {
    show();
    return;
  }

  setTimeout(show, 250);
}

export function showSnackbar(
  message: string,
  { actions, close = true, subtitle, variant = "success" }: TransientSnackbarOptions = {}
) {
  enqueueCustomSnackbar(message, { actions, close, subtitle, variant });
}

export function showErrorSnackbar(message: string, { actions, subtitle }: SnackbarOptions = {}) {
  enqueueCustomSnackbar(message, { actions, subtitle, variant: "error", persist: true });
}
